var React = require('react');

function PadlockUnlockedInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M12 10h7v10.154c0 1.23-.583 1.846-1.75 1.846H6.75C5.583 22 5 21.385 5 20.154V10h7zm-4 0V7a4 4 0 0 1 7.56-1.826","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.031 16.75a2 2 0 1 1 1.938 0c.02.08.031.164.031.25v1a1 1 0 0 1-2 0v-1c0-.086.01-.17.031-.25z","fill":"currentColor","key":1})]));
}

PadlockUnlockedInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = PadlockUnlockedInline;

PadlockUnlockedInline.default = PadlockUnlockedInline;
